import { TurbineStatusCard } from "./TurbineStatusCard";
export default TurbineStatusCard;
